export const labels = {
    login: 'وارد شوید',
    help: 'مشاهده راهنمای استفاده',
    notRegisteredYet:'هنوز ثبت نام نکرده ام',
    forgotYourPassword:'رمز عبور خود را فراموش کرده‌اید؟',
    email:'ایمیل',
    password:'رمزعبور'
}